(($) => {

    /**
     * check if an element is in-viewport
     *
     * @param options: object
     *    threshold : +100 (after 100px visible in viewport)
     *    threshold : -100 (100px visible before entering viewport)
     */
    $.fn.isInViewport = function (options) {

        // element
        var elementTop = $(this).offset().top,
            elementBottom = elementTop + $(this).outerHeight();

        // viewport
        var viewportTop = $(window).scrollTop(),
            viewportBottom = viewportTop + $(window).height();

        // settings
        var settings = $.extend({
            threshold: 0,
        }, options);

        // added threshold
        // return elementBottom > viewportTop && elementTop < viewportBottom;
        return (elementBottom - options.threshold) > viewportTop && (elementTop + settings.threshold) < viewportBottom;
    };

})( jQuery );


